import React from "react";

// Provisional logo — v0.1 (June 2026)
// Concept: two arcs (organic/body left + precision/data right) flanking
// a waveform that represents voice becoming structured clinical data.
// Full brand identity (designer-executed) scheduled pre-Series A.
// Do not modify colors or proportions without updating design system tokens.

const VARIANT_CONFIG = {
  default: { svg: 32, word: 20, gap: 10, opacity: 1 },
  small: { svg: 24, word: 16, gap: 8, opacity: 1 },
  footer: { svg: 28, word: 18, gap: 10, opacity: 0.85 },
};

export default function Logo({
  size,
  variant = "default",
  testId = "logo",
}) {
  const cfg = VARIANT_CONFIG[variant] || VARIANT_CONFIG.default;
  const svgSize = size || cfg.svg;
  const wordSize = cfg.word;

  return (
    <span
      className="logo"
      data-testid={testId}
      style={{ gap: `${cfg.gap}px`, opacity: cfg.opacity }}
    >
      <svg
        width={svgSize}
        height={svgSize}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Outer arc — brand purple, left */}
        <path
          d="M13 6 A10 10 0 0 0 13 26"
          stroke="#7B417B"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        {/* Inner arc — accent orange, right, slightly smaller */}
        <path
          d="M19 8 A8 8 0 0 1 19 24"
          stroke="#F18859"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
        {/* Waveform bars — voice becoming structured clinical data */}
        <rect x="14.5" y="12" width="1.5" height="8" rx="0.75" fill="#F0ECF8" opacity="0.9" />
        <rect x="17" y="10" width="1.5" height="12" rx="0.75" fill="#F18859" />
        <rect x="19.5" y="13" width="1.5" height="6" rx="0.75" fill="#F0ECF8" opacity="0.6" />
      </svg>

      <span
        className="logo-wordmark"
        style={{ fontSize: `${wordSize}px` }}
        aria-label="Akali AI"
      >
        <span className="logo-wordmark-akali">Akali </span>
        <span className="logo-wordmark-ai">AI</span>
      </span>
    </span>
  );
}
